<template>
  <div class="check">
    <CheckFormBox :title="$t('hzmbG.title.application')">
      <el-row :gutter="48" type="flex">
        <el-col :xs="24" :sm="12">
          <CheckRowText :label="$t('hzmbG.label.mobile')">
            <span v-if="verifyForm">
              +{{ verifyForm.mobileAreaCode }} {{ verifyForm.mobile }}
            </span>
          </CheckRowText>
        </el-col>
      </el-row>
    </CheckFormBox>
    <CheckFormBox :title="$t('hzmbG.title.vehicle')">
      <el-row :gutter="48" type="flex">
        <el-col :xs="24" :sm="12">
          <CheckRowText :label="$t('hzmbG.label.registrationNo')">{{
            form.vehicle && form.vehicle.hongKongRegistrationNo
          }}</CheckRowText>
        </el-col>
        <el-col :xs="24" :sm="12">
          <CheckRowText :label="$t('hzmbG.label.identificationNo')">{{
            form.vehicle && form.vehicle.identificationNo
          }}</CheckRowText>
        </el-col>
        <el-col :xs="24" :sm="12">
          <CheckRowText :label="$t('hzmbG.label.registrationType')">{{
            form.vehicle &&
            form.vehicle.registrationType | hkVehicleRegisterType
          }}</CheckRowText>
        </el-col>
        <el-col :xs="24" :sm="12">
          <CheckRowText :label="$t('hzmbG.label.factory')">
            <span v-if="form.vehicle && form.vehicle.factory && factoryNames">
              {{
                optionsLangText(findByBase(form.vehicle.factory, factoryNames))
              }}
            </span>
          </CheckRowText>
        </el-col>
        <el-col :xs="24" :sm="12">
          <CheckRowText :label="$t('hzmbG.label.modelType')">{{
            form.vehicle && form.vehicle.modelType
          }}</CheckRowText>
        </el-col>
        <el-col :xs="24" :sm="12">
          <CheckRowText :label="$t('hzmbG.label.buildYear')">{{
            form.vehicle && form.vehicle.buildYear
          }}</CheckRowText>
        </el-col>
        <el-col :xs="24" :sm="12">
          <CheckRowText :label="$t('hzmbG.label.firstRegisterDate')">{{
            form.vehicle &&
            form.vehicle.firstRegisterDate | formatDT("dd/MM/yyyy")
          }}</CheckRowText>
        </el-col>
        <el-col :xs="24" :sm="12">
          <CheckRowText :label="$t('hzmbG.label.color')">
            <span v-if="form.vehicle && form.vehicle.color && colors">
              {{ findByBase(form.vehicle.color, colors)[baseParameterLocale] }}
            </span>
          </CheckRowText>
        </el-col>
        <el-col v-if="!isTowTruck" :xs="24" :sm="12">
          <CheckRowText :label="$t('hzmbG.label.driverSeat')">
            {{ form.vehicle && form.vehicle.driverSeat | driverSeat }}
          </CheckRowText>
        </el-col>
        <el-col v-if="!isTowTruck" :xs="24" :sm="12">
          <CheckRowText :label="$t('hzmbG.label.passengerCount')">{{
            form.vehicle && form.vehicle.passengerCount
          }}</CheckRowText>
        </el-col>
        <el-col v-if="!isTowTruck" :xs="24" :sm="12">
          <CheckRowText :label="$t('hzmbG.label.engineNo')">
            <div v-if="form.vehicle">
              <p>{{ form.vehicle.engineNo1 }}</p>
              <p>{{ form.vehicle.engineNo2 }}</p>
              <p>{{ form.vehicle.engineNo3 }}</p>
              <p>{{ form.vehicle.engineNo4 }}</p>
            </div>
          </CheckRowText>
        </el-col>
        <el-col :xs="24" :sm="12">
          <CheckRowText :label="$t('hzmbG.label.permitWeight')"
            >{{ form.vehicle && form.vehicle.permitWeight }}
            {{ $t("hzmbG.message.ton") }}</CheckRowText
          >
        </el-col>
        <el-col :xs="24" :sm="12">
          <CheckRowText :label="$t('hzmbG.label.licenseExpireDate')">{{
            form.vehicle &&
            form.vehicle.licenseExpireDate | formatDT("dd/MM/yyyy")
          }}</CheckRowText>
        </el-col>
        <el-col :xs="24" :sm="12">
          <CheckRowText :label="$t('hzmbG.label.mainlandRegistrationNo')"
            >{{ form.vehicle && form.vehicle.mainlandNoPre }}
            {{
              form.vehicle && form.vehicle.mainlandRegistrationNo
            }}</CheckRowText
          >
        </el-col>
        <!-- <el-col :xs="24" :sm="12">
          <CheckRowText :label="$t('hzmbG.label.mainlandInsuranceNo')">{{
            form.vehicle && form.vehicle.mainlandInsuranceNo
          }}</CheckRowText>
        </el-col>
        <el-col :xs="24" :sm="12">
          <CheckRowText :label="$t('hzmbG.label.mainlandInsuranceStartDate')">{{
            form.vehicle &&
            form.vehicle.mainlandInsuranceStartDate | formatDT("dd/MM/yyyy")
          }}</CheckRowText>
        </el-col>
        <el-col :xs="24" :sm="12">
          <CheckRowText :label="$t('hzmbG.label.mainlandInsuranceEndDate')">{{
            form.vehicle &&
            form.vehicle.mainlandInsuranceEndDate | formatDT("dd/MM/yyyy")
          }}</CheckRowText>
        </el-col> -->
      </el-row>
    </CheckFormBox>
    <CheckFormBox :title="$t('hzmbG.title.owner')">
      <el-row :gutter="48" type="flex">
        <el-col :xs="24" :sm="12">
          <CheckRowText :label="$t('hzmbG.label.registerType')">{{
            form.owner && form.owner.registerType | registerType
          }}</CheckRowText>
        </el-col>
        <el-col v-if="form.owner.registerType === 'PERSON'" :xs="24" :sm="24">
          <CheckRowText :label="$t('hzmbG.label.ownerNameEn')">{{
            form.owner && form.owner.nameEn
          }}</CheckRowText>
        </el-col>
        <el-col v-if="form.owner.registerType === 'PERSON'" :xs="24" :sm="12">
          <CheckRowText :label="$t('hzmbG.label.identityType')">
            <span v-if="form.owner && form.owner.identityType && identityTypes">
              {{
                baseWithCodekey(
                  findByBase(form.owner.identityType, identityTypes)
                )
              }}
            </span>
          </CheckRowText>
        </el-col>
        <el-col v-if="form.owner.registerType === 'PERSON'" :xs="24" :sm="12">
          <CheckRowText :label="$t('hzmbG.label.identityNo')">{{
            form.owner && form.owner.identityNo
          }}</CheckRowText>
        </el-col>
        <el-col v-if="form.owner.registerType === 'PERSON'" :xs="24" :sm="24">
          <CheckRowText :label="$t('hzmbG.label.address')">
            <p>{{ form.owner && form.owner.address1 }}</p>
            <p>{{ form.owner && form.owner.address2 }}</p>
            <p>{{ form.owner && form.owner.address3 }}</p>
          </CheckRowText>
        </el-col>
        <el-col v-if="form.owner.registerType === 'COMPANY'" :xs="24" :sm="12">
          <CheckRowText :label="$t('hzmbG.label.ownerCompanyNameEn')">{{
            form.owner && form.owner.nameEn
          }}</CheckRowText>
        </el-col>
        <el-col v-if="form.owner.registerType === 'COMPANY'" :xs="24" :sm="12">
          <CheckRowText :label="$t('hzmbG.label.companyIdentityType')">
            <span
              v-if="
                form.owner &&
                form.owner.companyIdentityType &&
                companyIdentityTypes
              "
            >
              {{
                baseWithCodekey(
                  findByBase(
                    form.owner.companyIdentityType,
                    companyIdentityTypes
                  )
                )
              }}
            </span>
          </CheckRowText>
        </el-col>
        <el-col v-if="form.owner.registerType === 'COMPANY'" :xs="24" :sm="12">
          <CheckRowText :label="$t('hzmbG.label.companyRegisterNo')">{{
            form.owner && form.owner.companyRegisterNo
          }}</CheckRowText>
        </el-col>
        <el-col v-if="form.owner.registerType === 'COMPANY'" :xs="24" :sm="24">
          <CheckRowText :label="$t('hzmbG.label.companyAddress')">
            <p>{{ form.owner && form.owner.address1 }}</p>
            <p>{{ form.owner && form.owner.address2 }}</p>
            <p>{{ form.owner && form.owner.address3 }}</p>
          </CheckRowText>
        </el-col>
        <el-col :xs="24" :sm="12">
          <CheckRowText :label="$t('hzmbG.label.macauMobile')">
            +{{ form.owner && form.owner.mobileAreaCode }}
            {{ form.owner && form.owner.macauMobile }}</CheckRowText
          >
        </el-col>
        <el-col :xs="24" :sm="12">
          <CheckRowText :label="$t('hzmbG.label.email')">
            {{ form.owner && form.owner.email }}</CheckRowText
          >
        </el-col>
      </el-row>
    </CheckFormBox>
    <CheckFormBox v-if="!isTowTruck" :title="$t('hzmbG.title.drivers')">
      <div v-for="(item, index) in form.drivers || []" :key="index">
        <div class="check_drivers_title">
          {{
            $t("hzmbG.title.driversIndex", [
              $t(`message.capitalLetter[${index + 1}]`),
            ])
          }}
        </div>
        <el-row :gutter="48" type="flex">
          <el-col :xs="24" :sm="24">
            <CheckRowText :label="$t('hzmbG.label.driverNameEn')">{{
              item.nameEn
            }}</CheckRowText>
          </el-col>
          <el-col :xs="24" :sm="12">
            <CheckRowText :label="$t('hzmbG.label.identityType')">
              {{
                baseWithCodekey(findByBase(item.identityType, identityTypes))
              }}
            </CheckRowText>
          </el-col>
          <el-col :xs="24" :sm="12">
            <CheckRowText :label="$t('hzmbG.label.identityNo')">{{
              item.identityNo
            }}</CheckRowText>
          </el-col>
          <el-col :xs="24" :sm="12">
            <CheckRowText :label="$t('hzmbG.label.hongKongDrivingLicenseType')">
              {{
                optionsLangText(
                  findByBase(
                    item.hongKongDrivingLicenseType,
                    hongKongDrivingLicenseTypes
                  )
                )
              }}
            </CheckRowText>
          </el-col>
          <el-col :xs="24" :sm="12">
            <CheckRowText :label="$t('hzmbG.label.hongKongDrivingLicenseNo')">{{
              item.hongKongDrivingLicenseNo
            }}</CheckRowText>
          </el-col>
          <!-- <el-col :xs="24" :sm="12">
            <CheckRowText :label="$t('hzmbG.label.mainlandDrivingFileNo')">{{
              item.mainlandDrivingFileNo
            }}</CheckRowText>
          </el-col>
          <el-col :xs="24" :sm="12">
            <CheckRowText :label="$t('hzmbG.label.mainlandDrivingLicenseNo')">{{
              item.mainlandDrivingLicenseNo
            }}</CheckRowText>
          </el-col> -->
          <el-col :xs="24" :sm="12">
            <CheckRowText :label="$t('hzmbG.label.birthday')">{{
              item.birthday | formatDT("dd/MM/yyyy")
            }}</CheckRowText>
          </el-col>
          <el-col :xs="24" :sm="12">
            <CheckRowText :label="$t('hzmbG.label.sex')">
              {{ findByBase(item.sex, sexs)[idTypeLocalce] }}
            </CheckRowText>
          </el-col>
          <el-col :xs="24" :sm="12">
            <CheckRowText :label="$t('hzmbG.label.nationality')">
              {{ findByBase(item.nationality, nationalitys)[idTypeLocalce] }}
            </CheckRowText>
          </el-col>
          <el-col :xs="24" :sm="12">
            <CheckRowText :label="$t('hzmbG.label.macauMobile')">
              +{{ item.mobileAreaCode }} {{ item.mobile }}
            </CheckRowText>
          </el-col>
          <el-col :xs="24" :sm="12">
            <CheckRowText :label="$t('hzmbG.label.email')"
              >{{ item.email }}
            </CheckRowText>
          </el-col>
          <el-col :xs="24" :sm="12">
            <CheckRowText :label="$t('hzmbG.label.address')">
              <p>{{ item.address1 }}</p>
              <p>{{ item.address2 }}</p>
              <p>{{ item.address3 }}</p>
            </CheckRowText>
          </el-col>
        </el-row>
      </div>
    </CheckFormBox>

    <div class="check_title">
      {{ $t("message.DataRegistration.check.already_upload_file") }}
    </div>
    <div class="check_file_list">
      <div
        v-for="(item, index) in form.documents"
        :key="item.id"
        class="check_file_list_content"
      >
        <div v-if="item.file">
          <span
            >{{ index + 1 }}.{{
              item.documentType &&
              item.documentType[`name${$t("message.lan")}`]
            }}：</span
          >
          <span class="check_file_name"
            >&nbsp;{{ item.file && item.file.filename }}</span
          >
        </div>
      </div>
    </div>
    <div class="check_agree">
      <div class="check-table-title">
        {{ $t("hzmbG.message.vehicleSize.title") }}
      </div>
      <el-table
        :data="[
          {
            type: $t('hzmbG.message.vehicleType1'),
            length: '12 m',
            weight: '2.5 m',
            height: '4.6 m',
          },
          {
            type: $t('hzmbG.message.vehicleType2'),
            length: '15 m',
            weight: '2.5 m',
            height: '4.6 m',
          },
          {
            type: $t('hzmbG.message.vehicleType3'),
            length: '18 m',
            weight: '2.5 m',
            height: '4.6 m',
          },
        ]"
        class="m-popover-table"
        border
        :span-method="vehicleSizeSpanMethod"
        style="width: 100%"
      >
        <el-table-column
          :label="$t('hzmbG.message.vehicleType')"
          prop="type"
          width="170px"
        ></el-table-column>
        <el-table-column :label="$t('hzmbG.message.vehicleSize.max')">
          <el-table-column
            :label="$t('hzmbG.message.vehicleSize.length')"
            prop="length"
          ></el-table-column>
          <el-table-column
            :label="$t('hzmbG.message.vehicleSize.weight')"
            prop="weight"
          ></el-table-column>
          <el-table-column
            :label="$t('hzmbG.message.vehicleSize.height')"
            prop="height"
          ></el-table-column>
        </el-table-column>
      </el-table>
      <div style="margin-top: 24px">{{ $t("hzmbG.message.checkTips") }}</div>
      <el-checkbox v-model="agree" class="check-agree-checkbox">
        {{ $t("hzmbG.message.agreeVehicleSize") }}
      </el-checkbox>
    </div>
    <div class="next_btn">
      <GradientBtn @click="back">{{ $t("message.back") }} </GradientBtn>
      <GradientBtn @click="onSubmit" :loading="submitLoading"
        >{{ $t("message.DataRegistration.check.submit") }}
      </GradientBtn>
    </div>
  </div>
</template>

<script>
import CheckFormBox from "../../Check/components/CheckFormBox.vue";
import CheckRowText from "@/components/CheckRowText.vue";
import GradientBtn from "@/components/GradientBtn.vue";
import HzmbGFirstApplicationAPI from "@/api/hzmb-gh/HzmbGFirstApplicationAPI";
import VssViewAPI from "@/api/hzmb-gh/VssViewAPI";
import { registerType, hkVehicleRegisterType, driverSeat } from "@/filters";
import BaseParameterAPI from "@/api/hzmb-gh/BaseParameterAPI";
export default {
  components: { CheckFormBox, CheckRowText, GradientBtn },
  filters: { registerType, hkVehicleRegisterType, driverSeat },
  data() {
    return {
      serviceType: this.$route.meta.serviceType,
      applicationId: this.$route.params.applicationId,
      loading: false,
      form: {
        drivers: [{}, {}],
        vehicle: {},
        owner: {},
      },
      verifyForm: {},
      identityTypes: [],
      companyIdentityTypes: [],
      sexs: [],
      nationalitys: [],
      identificationTypes: [],
      factoryNames: [],
      colors: [],
      hongKongDrivingLicenseTypes: [],
      submitLoading: false,
      agree: null,
    };
  },
  computed: {
    idTypeLocalce() {
      return (
        ["codeCname", "codePname"][
          ["ZH_TW", "PT"].indexOf(this.$i18n.locale)
        ] || "codeMasterCname"
      );
    },
    baseParameterLocale() {
      return (
        ["nameCn", "namePt"][["ZH_TW", "PT"].indexOf(this.$i18n.locale)] ||
        "nameCn"
      );
    },
    findByBase() {
      return (value, data, name = "codeKey") => {
        const obj = data.find((e) => e[name] === value);
        if (obj) return obj;
        else return {};
      };
    },
    baseWithCodekey() {
      return (obj) => {
        if (!obj) return "";
        const { codeKey, codeCname, codePname } = obj;
        return `${codeKey}-${codeCname}-${codePname}`;
      };
    },
    // 是否為拖車類型
    isTowTruck() {
      const { registrationType } = this.form.vehicle;
      return registrationType && registrationType === "TOW_TRUCK";
    },
    optionsLangText() {
      return (value) => {
        if (value) {
          const { nameCn, namePt } = value;
          return `${nameCn || ""}${nameCn && namePt ? "-" : ""}${namePt || ""}`;
        } else {
          return "";
        }
      };
    },
  },
  methods: {
    vehicleSizeSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex > 1) {
        if (rowIndex === 0) {
          return {
            rowspan: 3,
            colspan: 1,
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }
    },
    back() {
      this.$router.push(`/hzmb-g-first/upload/${this.applicationId}`);
    },
    async onSubmit() {
      if (!this.agree) {
        this.$message({
          type: "error",
          message: "請勾選同意",
        });
        return;
      }
      try {
        await this.$confirm(
          this.$t("message.confirm_submit_content"),
          this.$t("message.tips"),
          {
            confirmButtonText: this.$t("message.confirm"),
            cancelButtonText: this.$t("message.cancel"),
            type: "warning",
            dangerouslyUseHTMLString: true,
          }
        );
      } catch (error) {
        return;
      }
      try {
        this.submitLoading = true;
        const { id } = this.form;
        if (!id) return;
        const { applicationNo } = await HzmbGFirstApplicationAPI.submit(id);
        this.$router.push({
          path: "/hzmb-g-first/success",
          query: {
            applicationNo,
            id,
          },
        });
      } catch (error) {
        this.$error(error);
      } finally {
        this.submitLoading = false;
      }
    },
    async get() {
      try {
        this.loading = true;
        let form = await HzmbGFirstApplicationAPI.getById(this.applicationId);
        this.$set(this, "form", form);
      } catch (error) {
        if (error.code === "DUPLICATE_APPROVING_APPLICATION") {
          this.$alert(
            this.$t("message.ErrorMessage.DUPLICATE_APPROVING_APPLICATION")
          );
          this.$router.replace(`/hzmb-truck-hk`);
        } else {
          this.$error(error);
        }
      } finally {
        this.loading = false;
      }
    },
    async getBase() {
      try {
        this.identityTypes = await VssViewAPI.getHzmbGIdType();
        this.companyIdentityTypes = await VssViewAPI.getHzmbGByType("COMPANY");
        this.sexs = await VssViewAPI.getsexs();
        this.nationalitys = await VssViewAPI.getNationalitys();
        this.identificationTypes = await BaseParameterAPI.getBaseParameter(
          "HK_VEH_REGISTRATION_ID_TYPE"
        );
        this.colors = await BaseParameterAPI.getBaseParameter("COLOR");
        this.hongKongDrivingLicenseTypes =
          await BaseParameterAPI.getBaseParameter("HK_DRIVING_LICENSE_TYPE");
        this.factoryNames = await BaseParameterAPI.getBaseParameter(
          "VEH_FACTORY_NAME"
        );
      } catch (error) {
        this.$error(error);
      }
    },
  },
  created() {
    this.verifyForm = JSON.parse(localStorage.getItem("verifyForm")) || {};
    this.get();
    this.getBase();
  },
};
</script>

<style lang="scss" scoped>
.check {
  background: #fff;
  overflow: hidden;
  padding: 0 14px;
  max-width: 1200px;
  overflow: hidden;
  margin: auto;
}
.check_drivers_title {
  margin-bottom: 24px;
  font-size: 18px;
  font-weight: 500;
  color: rgba(50, 50, 50, 1);
  line-height: 25px;
}
.el-row {
  align-items: flex-start;
}

.check_title {
  max-width: 867px;
  margin: auto;
  font-size: 18px;
  font-weight: 500;
  line-height: 25px;
  color: #262626;
  border-bottom: 3px solid #38959d;
  padding: 16px 0;
}
.check_file_list {
  max-width: calc(867px - 48px);
  width: calc(100% - 48px);
  margin: 24px auto;
  border-radius: 8px;
  border: 1px solid rgba(151, 151, 151, 1);
  padding: 24px;
}
.check_file_list_content {
  max-width: 760px;
  margin: auto;
  margin-bottom: 24px;
  font-size: 16px;
  line-height: 22px;
}
.check_file_name {
  color: #5ba7ad;
}
.check_agree {
  max-width: calc(867px - 48px);
  width: calc(100% - 48px);
  margin: 24px auto;
  border-radius: 8px;
  border: 1px solid rgba(151, 151, 151, 1);
  padding: 24px;
}
.m-popover-table {
  /deep/th {
    background: #5ba7ad !important;
    color: #fff;
    text-align: center;
    padding: 6px 0;
  }
  /deep/td {
    text-align: center;
  }
}
.check-table-title {
  font-size: 14px;
  margin-bottom: 12px;
}
/deep/.check-agree-checkbox.el-checkbox {
  margin-top: 8px;
  white-space: normal;
  display: flex;
  flex-direction: row;
  align-items: center;
  .el-checkbox__label {
    font-size: 16px;
  }
}
</style>
